export const PAYMENT_MODAL_TITLES = {
	PAY_LUMP_SUM: "Pay Lump Sum",
	PAY_SELECTED: "Pay Selected",
	MAKE_PAYMENT: "Make A Payment",
} as const;

export const PAYMENT_CONSTRAINTS = {
	MIN_AMOUNT: 1,
	MAX_AMOUNT: 9_999_999.99,
	DESCRIPTION_MAX_LENGTH: 250,
} as const;

export const MOCK_OUTSTANDING_BALANCE = 8750;

export const COUNTRY_CODE_MAP: Record<string, string> = {
	USA: "US",
	Canada: "CA",
	Mexico: "MX",
};

export const US_STATE_CODES: Record<string, string> = {
	alabama: "AL",
	alaska: "AK",
	arizona: "AZ",
	arkansas: "AR",
	california: "CA",
	colorado: "CO",
	connecticut: "CT",
	delaware: "DE",
	florida: "FL",
	georgia: "GA",
	hawaii: "HI",
	idaho: "ID",
	illinois: "IL",
	indiana: "IN",
	iowa: "IA",
	kansas: "KS",
	kentucky: "KY",
	louisiana: "LA",
	maine: "ME",
	maryland: "MD",
	massachusetts: "MA",
	michigan: "MI",
	minnesota: "MN",
	mississippi: "MS",
	missouri: "MO",
	montana: "MT",
	nebraska: "NE",
	nevada: "NV",
	"new hampshire": "NH",
	"new jersey": "NJ",
	"new mexico": "NM",
	"new york": "NY",
	"north carolina": "NC",
	"north dakota": "ND",
	ohio: "OH",
	oklahoma: "OK",
	oregon: "OR",
	pennsylvania: "PA",
	"rhode island": "RI",
	"south carolina": "SC",
	"south dakota": "SD",
	tennessee: "TN",
	texas: "TX",
	utah: "UT",
	vermont: "VT",
	virginia: "VA",
	washington: "WA",
	"west virginia": "WV",
	wisconsin: "WI",
	wyoming: "WY",
};

export const INITIAL_NEW_PAYMENT_VALUES = {
	cardholderName: "",
	bankName: "",
	// bankAccountNumber and routingNumber are non-PCI and can stay in state for ACH
	bankAccountNumber: "",
	routingNumber: "",
	accountHolderName: "",
	ownershipType: "personal",
	accountType: "checking",
	billingAddress1: "",
	billingAddress2: "",
	city: "",
	state: "",
	country: "USA",
	zip: "",
	isDefault: false,
};
